module.exports = __webpack_public_path__ + "static/media/logo_white.872b46b5.svg";